import { Path, Transforms } from 'slate'

import { CustomEditor } from '../../interface/custom-types'

import { getSubListEntry } from './getSubListEntry'

/**
 * Pour the nested list of the given list item into the nested list right before it,
 * so that an item moved to a deeper level continues the list already existing on that
 * level instead of starting a list of its own, which would restart the numbering.
 */
export const mergeWithPreviousSubList = (editor: CustomEditor, listItemPath: Path) => {
  if (!Path.hasPrevious(listItemPath)) {
    return
  }

  const previousSubList = getSubListEntry(editor, Path.previous(listItemPath))
  const currentSubList = getSubListEntry(editor, listItemPath)

  if (!previousSubList || !currentSubList || previousSubList[0].type !== currentSubList[0].type) {
    return
  }

  const [previousListNode, previousListPath] = previousSubList
  const [currentListNode, currentListPath] = currentSubList
  const firstMovedItemIndex = previousListNode.children.length

  currentListNode.children.forEach((_, movedItemIndex) => {
    Transforms.moveNodes(editor, {
      at: [...currentListPath, 0],
      to: [...previousListPath, firstMovedItemIndex + movedItemIndex],
    })
  })

  Transforms.removeNodes(editor, { at: listItemPath })
}
